/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Controls/Locked': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M11.249 10.991h1.502a.25.25 0 00.249-.25V7.736C13 6.01 14.492 5 16 5c1.509 0 3 1.01 3 2.736v3.005c0 .138.111.25.249.25h1.502a.25.25 0 00.249-.25V7.736C21 5.01 18.611 3 16 3s-5 2.01-5 4.736v3.005c0 .138.111.25.249.25m4.002 10.01h1.498a.251.251 0 00.252-.252v-3.498a.251.251 0 00-.253-.25h-1.497a.25.25 0 00-.25.25v3.498a.25.25 0 00.25.251M23 22a3 3 0 01-3 3h-8a3 3 0 01-3-3v-8h14v8zm1.75-10H7.25a.25.25 0 00-.25.25V22a5 5 0 005 5h8a5 5 0 005-5v-9.75a.25.25 0 00-.25-.25z"/>'
  }
})
